<template>
  <div class="bg-white px-3 index">
    <div class="add_tits" ref="titles">
      <el-form class="form-inlines" :inline="true">
        <div class="u-f u-ac u-jsb">
          <div>
            <el-form-item>
              <el-date-picker v-model="timer1" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small">
              </el-date-picker>
              <!-- <el-input placeholder="请输入内容" v-model="searchValue" clearable size="small"
              style="width: 200px; margin-right: 10px; margin-left: 10px">
            </el-input> -->
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
            </el-form-item>
          </div>
          <el-form-item>
            <el-popover placement="top" v-model="visible" @show='handleAdd'>
              <el-form :model="ruleForm" ref="ruleForm" label-width="80px" class="demo-ruleForm">
                <el-form-item label="优惠券" style="margin-top: 10px" prop="type_id">
                  <el-select v-model="ruleForm.type_id" placeholder="请选择" size="small">
                    <el-option v-for="(y, index) in yhq_options" :key="index" :label="y.name" :value="y.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="submit('ruleForm')">确定</el-button>
              </div>
              <el-button type="primary" slot="reference" icon="el-icon-circle-plus-outline" size="small">优惠券设置
              </el-button>
            </el-popover>

          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="ibox-content">
      <el-table :data="tableData" :height="height" border v-loading="loading">
        <el-table-column prop="inviter_id" label="识别码"></el-table-column>
        <el-table-column prop="user_name" label="用户" show-overflow-tooltip></el-table-column>
        <el-table-column prop="invite_count" label="邀请人数"></el-table-column>
        <el-table-column prop="join_time" label="日期"></el-table-column>
        <el-table-column label="是否领取">
          <template slot-scope="scope">
            {{ { 0: "未领取", 1: "已领取" }[scope.row.is_coupon] }}
          </template>
        </el-table-column>
      </el-table>
      <div class="u-f u-ac u-jsb ft_mr">
        <div></div>
        <div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[15, 30, 50, 70, 100]" :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="count">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="优惠券设置" :visible.sync="dialogVisible" center top="20px" class="dialogs" append-to-body>
      <el-divider></el-divider>
      <div class="dialog-ibox-content">
        <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="优惠券" style="margin-top: 10px" prop="type_id">
            <el-select v-model="ruleForm.type_id" placeholder="请选择" size="small">
              <el-option v-for="(y, index) in yhq_options" :key="index" :label="y.name" :value="y.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
  import {
    mapState
  } from "vuex";
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        currentPage: 1,
        pagesize: 15,
        count: 0,
        height: null,
        dialogVisible: false,
        subloading: false,
        ruleForm: {
          type_id: "",
        },
        yhq_options: [],
        timer1: "",
        searchValue: "",
        visible: false,
      };
    },
    computed: {
      ...mapState({
        user: (state) => state.user.user,
      }),
    },
    mounted() {
      let that = this;
      that.getHeight();
      that.begin();
      this.getyhq();
    },
    methods: {
      getHeight() {
        let that = this;
        var titles = that.$refs.titles.offsetHeight;
        that.height = window.innerHeight - titles - 200 + "px";
        window.onresize = () => {
          var titles = that.$refs.titles.offsetHeight;
          that.height = window.innerHeight - titles - 200 + "px";
        };
      },
      getyhq() {
        this.ruleForm.type_id = "";
        this.yhq_options = [];
        axios
          .get(
            `/admin/wss/coupon/allCouponSelect?couponType=1`, {}, {
              token: true,
            }
          )
          .then((response) => {
            if (response.data.code == "200") {
              this.yhq_options = response.data.data;
              // this.getyhqValue();
            } else {
              this.$message.error(response.data.msg);
            }
          })
          .catch((error) => {});
      },
      getyhqValue() {
        axios
          .post(
            `/admin/invite/couponDetail`, {}, {
              token: true,
            }
          )
          .then((response) => {
            if (response.data.code == "200") {
              this.ruleForm.type_id = response.data.data.id;
            } else {
              this.$message.error(response.data.msg);
            }
          })
          .catch((error) => {});
      },
      // 搜索
      begin() {
        let that = this;
        that.currentPage = 1;
        that.search();
      },
      search() {
        let that = this;
        that.loading = true;
        axios
          .post(
            `/admin/invite/allInviteUser`, {
              page: this.currentPage,
              page_count: this.pagesize,
              start: this.timer1[0],
              end: this.timer1[1],
              name: this.searchValue,
            }, {
              headers: {
                token: this.user.token,
              },
            }
          )
          .then((response) => {
            that.loading = false;
            that.tableData = response.data.data.list;
            that.count = response.data.data.totalCount;
          })
          .catch((error) => {});
      },
      handleSizeChange(val) {
        let that = this;
        that.pagesize = val;
        that.search();
      },
      handleCurrentChange(val) {
        let that = this;
        that.currentPage = val;
        that.search();
      },
      handleAdd() {
        let that = this;
        // that.dialogVisible = true;
        that.eid = "";
        this.getyhqValue();
      },
      form_clear() {
        let that = this;
        that.ruleForm = {
          end_time: "",
          start_time: "",
          value: "",
          min_price: "",
          total: "",
          type: "",
          status: "",
          name: "",
          desc: "",
          order: 50,
          sys_default: 2,
          use_channel: 1,
          expire_day: 0,
          expire_type: 1,
        };
      },
      submit(formName) {
        let that = this;
        if (this.ruleForm.type_id !== "") {
          that.subloading = true;
          axios
            .post(
              "admin/invite/setCoupon", {
                coupon_mall_id: this.ruleForm.type_id,
              }, {
                token: true,
              }
            )
            .then((response) => {
              that.subloading = false;
              if (response.data.code == 200) {
                that.visible = false;
                that.search();
                that.$message({
                  message: "操作成功",
                  type: "success",
                });
              } else {
                that.$message.error(response.data.msg);
              }
            })
            .catch((error) => {
              that.subloading = false;
            });
        } else {
          return false;
        }
      },

    },
  };
</script>


<style scoped>
</style>